import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KindEnum } from 'wflow-variables';
import { IconsModule, WuiButtonModule, WuiTooltip } from 'wflow-ui';
import { getOrgPath } from 'wflow-main-app/src/app/shared/utils/route.utils';

@Component({
  selector: 'wf-peppol-detail-document-row',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, IconsModule, WuiButtonModule, WuiTooltip],
  templateUrl: './peppol-detail-document-row.component.html',
  styleUrl: './peppol-detail-document-row.component.scss',
  host: { class: 'wf-peppol-detail-document-row' },
})
export class PeppolDetailDocumentRowComponent {
  readonly documentId = input<string | undefined>(undefined);
  readonly documentNumber = input<string | undefined>(undefined);
  readonly documentKind = input<KindEnum | undefined>(undefined);

  readonly createDocumentRequested = output<void>();

  protected readonly documentUrl = computed<string | null>(() => {
    const id = this.documentId();
    return id ? `${getOrgPath()}/documents/detail/${id}` : null;
  });
}
